import {useMutation} from "@apollo/client";
import omit from "lodash/omit";

import {GQL_CONTACT} from "@/lib/queries/website.ts";
import {ResponseStatus} from "@/lib/types/common.ts";
import {ContactForm} from "@/pages/website/contact/ContactForm.tsx";

import {ContactFormData} from "./contactFormTypes";

export const ContactFormAction = () => {
  const [submitContact, {data}] = useMutation(GQL_CONTACT, {
    context: {
      noToast: true,
    },
  });

  const handleSubmit = async (data: ContactFormData) => {
    const prunedData = omit(data, ["startTime"]);
    const fillTime = Math.floor((new Date().getTime() - data.startTime.getTime()) / 1000);

    const resp = await submitContact({
      variables: {data: {...prunedData, ft: fillTime}},
    });
    if (resp.data?.response?.status === ResponseStatus.ERROR) {
      return;
    }
  };

  const serverErrors = data?.response?.status === ResponseStatus.ERROR ? data?.response?.message : [];

  return data?.response?.status === ResponseStatus.SUCCESS ? (
    <>
      <h3 className="mt-2 mb-4">Thanks for your message.</h3>
      <p>We will respond shortly.</p>
    </>
  ) : (
    <ContactForm onSubmit={handleSubmit} serverErrors={serverErrors} />
  );
};
